module.exports = __webpack_public_path__ + "media/images/allow_right_brown-085b52f2c008a5f73448ba0109c16aaf.svg";